class TrackingFirstInteraction {

    static STORAGE_KEY = 'trk-fi';

    triggerFirstInteraction() {
        if (typeof _satellite !== 'undefined') {
            let formName = 1
            let fis = sessionStorage.getItem(TrackingFirstInteraction.STORAGE_KEY);
            if(fis){fis = fis.split(',')}

            if( digitalData !== 'undefined' && digitalData.form.formName !== 'undefined'){
                formName = digitalData.form.formName
            }

            if(!fis || !fis.includes(formName)){
                if(!fis){
                    fis = [];
                }
                _satellite.track('firstInteraction')
                fis.push(formName)
                sessionStorage.setItem(TrackingFirstInteraction.STORAGE_KEY, fis.join(','))
            }
        }
    }

    resetFirstInteractionStorage() {
        let fis = sessionStorage.getItem(TrackingFirstInteraction.STORAGE_KEY);
        let formName = 1
        if(fis){fis = fis.split(',')}
        if( digitalData !== 'undefined' && digitalData.form.formName !== 'undefined'){
            formName = digitalData.form.formName
        }

        if(fis && fis.includes(formName)){
           fis = fis.filter(fi=>(fi !== formName))
            if(fis.length < 1){
                sessionStorage.removeItem(TrackingFirstInteraction.STORAGE_KEY)
            }
            else{
                sessionStorage.setItem(TrackingFirstInteraction.STORAGE_KEY, fis.join(','))
            }
        }
    }

    initFormFillingInteraction($form) {
        $form.addEventListener('change', function () {
           this.triggerFirstInteraction()
        });
    }

}
export default TrackingFirstInteraction
